import { appState } from './state';
import { renderLogin } from './pages/login';
import { renderDevices } from './pages/devices';
import { renderSettings } from './pages/settings';
import { renderAddressBook } from './pages/address-book';
import { renderWebAuthn } from './pages/webauthn';
import { renderAdminPage } from './pages/admin';
import { renderAbout } from './pages/about';
import { renderMeeting } from './pages/meeting';
import { renderFileTransfer } from './pages/file-transfer';
import { renderChat } from './pages/chat';
import { renderDashboard } from './pages/dashboard';
import { withShell } from './ui/components/shell';
// (placeholderPage Faz 9'da kalktı — tüm route'lar gerçek sayfalara bağlı.)
function routeFor(route) {
    switch (route) {
        case 'connect':
            return {
                render: () => renderDevices(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Bağlan', active: true }],
            };
        case 'panel':
            return {
                render: () => renderDashboard(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Panel', active: true }],
            };
        case 'contacts':
            return {
                render: () => renderAddressBook(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Kişiler', active: true }],
            };
        case 'files':
            return {
                render: () => renderFileTransfer(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Dosya Transferi', active: true }],
            };
        case 'meeting':
            return {
                render: () => renderMeeting(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Toplantı', active: true }],
            };
        case 'chat':
            return {
                render: () => renderChat(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Sohbet', active: true }],
            };
        case 'settings':
            return {
                render: () => renderSettings(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Ayarlar', active: true }],
            };
        case 'webauthn':
            return {
                render: () => renderWebAuthn(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Anahtarlar', active: true }],
            };
        case 'admin':
            return {
                render: () => renderAdminPage(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Admin', active: true }],
            };
        case 'about':
            return {
                render: () => renderAbout(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Hakkında', active: true }],
            };
        default:
            return {
                render: () => renderDevices(),
                breadcrumbs: [{ label: 'PhotonRemote' }, { label: 'Bağlan', active: true }],
            };
    }
}
export function renderApp(root) {
    root.innerHTML = '';
    if (!appState.isAuthenticated) {
        root.append(renderLogin());
        return;
    }
    const spec = routeFor(appState.currentRoute);
    root.append(withShell({
        activeRoute: appState.currentRoute,
        breadcrumbs: spec.breadcrumbs,
        searchPlaceholder: spec.searchPlaceholder,
        content: spec.render(),
    }));
}
